export const transactionExplorerMediator = (chainId: number) => {
  if (chainId === 12340001 || chainId === 12340002) {
    return '/transaction/';
  }

  return '/tx/';
};
